import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  dark?: boolean;
}

const Close = ({ dark = false, ...props }: Props) => {
  const { palette }: Theme = useTheme();
  const color = dark ? palette.secondary.dark : '#B3B3B0';
  return (
    <SvgIcon {...props} viewBox="0 0 21 23">
      <path
        d="M8.62971 10.9998L0.333496 19.296L2.70382 21.6663L21.6664 2.70367L19.2961 0.333344L11 8.62942L2.70396 0.333344L0.333631 2.70367L8.62971 10.9998Z"
        fill={color}
      />
      <path d="M15.741 13.3704L21.6668 19.2962L19.2965 21.6665L13.3707 15.7407L15.741 13.3704Z" fill={color} />
    </SvgIcon>
  );
};

export default memo(Close);
